<template>
  <div>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/na/000.png')"
        caption="[거북아, 바다로 달리자] 594 x 841mm 포스터, 세로형"
      />
      <article>
        <h1>
          [거북아, 바다로 달리자]
        </h1>
        <p class="desc">
          거북이와 토끼의 달리기 한 판 승부를 아는가? 육지라는 불리한 조건임에도
          불구, 결국 거북이는 승리를 쟁취했다. 묵묵히 노력하는 거북이의 열정을
          담아 26개의 그룹들이 참여하는 [RUN TO OCEAN FESTIVAL]을 개최한다.
          ‘스물여섯개의 그룹들이 전하는 각자의 인생 달리기’ 라는 테마를 가진
          가상 페스티벌이다. 바닷속에서 자유롭게 유영하는 거북이를 표현했으며,
          거북이의 형태와 무게감에서 그래픽 모티브를 착안해 레터링을 제작하였다.
        </p>
      </article>
    </section>
    <hr />
    <section class="mb-5">
      <image-element :src="require('@/assets/Projects/na/001.png')" />
      <image-element :src="require('@/assets/Projects/na/002.png')" />
      <p class="desc">
        각기 다른 크기와 모양을 가진 물방울을 통해 심해에서 헤엄쳐 올라오는
        거북이를 보다 역동적으로 표현하였다. 수평으로 흐르는 물살과 하단에서
        올라오는 물방울의 교차는 바다에 한층 더 생동감을 불어넣어준다.
      </p>
    </section>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/na/003.png')"
        caption=" 목업, 런투오션페스티벌, 풍선"
      />
      <p class="desc">
        페스티벌의 분위기에 맞는 풍선을 제작한다. 공중에 떠있는 풍선 속 거북이는
        마치 허공을 자유롭게 유영하는 듯하다.
      </p>
    </section>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/na/004.png')"
        caption="목업, 런투오션페스티벌, 행잉배너"
      />
      <p class="desc">
        페스티벌의 분위기에 맞는 행잉배너를 제작한다. 흥미 유발을 위한 목적으로,
        정보성 배너가 아님을 명시한다.
      </p>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
